/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';

import './animation014.less';

interface IAnimation014Item {
  text: string;
  title: string;
}

interface IAnimation014Props {
  items: IAnimation014Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation014: React.FunctionComponent<IAnimation014Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const [subStepStatus, setSubStepStatus] =
    React.useState<Record<string, boolean>>();
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');

  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      onCompleted && onCompleted();
    }
  };

  const handleSubStepClick = (event: Event, currentStep: number) => {
    if (event && currentStep) {
      const updatedStatus = Object.assign({}, subStepStatus);
      updatedStatus[currentStep] = true;
      setSubStepStatus(updatedStatus);
    }
  };

  React.useEffect(() => {
    const subStepStatusList: Record<string, boolean> = {};
    const subStepList: number[] = [];
    if (playFlag) {
      setSubStepStatus(subStepStatusList);
    }
    const subTasks = document.querySelectorAll('.sub-task-text');
    if (subTasks) {
      subTasks.forEach((task, index) =>
        task.addEventListener('click', (event: Event) =>
          handleSubStepClick(event, subStepList[index])
        )
      );
      return () =>
        subTasks.forEach((task, index) =>
          task.removeEventListener('click', (event: Event) =>
            handleSubStepClick(event, subStepList[index])
          )
        );
    }
  }, [playFlag]);

  return (
    <div ref={crrRef} className={`animation014 component ${className || ''}`}>
      {items.map((itm: IAnimation014Item, idx: number) => (
        <div
          key={idx}
          className={`animation014-item r${idx + 1} animation ${
            play >= idx + 1 ? 'fade-in' : ''
          }`}
          onClick={() => startPlay()}
        >
          <img
            className={`click-point ${play > 1 ? 'hide' : ''}`}
            src={ImgPoint}
            alt=""
          />
          <div
            className="animation014-header"
            dangerouslySetInnerHTML={{ __html: itm.title }}
          />
          <div
            className="animation014-text"
            dangerouslySetInnerHTML={{ __html: itm.text }}
          />
        </div>
      ))}
    </div>
  );
};

export default Animation014;
